/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_date_range_picker__departure_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Abreise`
};

const en_date_range_picker__departure_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Departure`
};

const es_date_range_picker__departure_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Salida`
};

const fr_date_range_picker__departure_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Départ`
};

const it_date_range_picker__departure_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Partenza`
};

const nl_date_range_picker__departure_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Vertrek`
};

const pt_date_range_picker__departure_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Partida`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__departure_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.date_range_picker__departure_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("date_range_picker__departure_placeholder", locale)
	if (locale === "de") return de_date_range_picker__departure_placeholder(inputs)
	if (locale === "en") return en_date_range_picker__departure_placeholder(inputs)
	if (locale === "es") return es_date_range_picker__departure_placeholder(inputs)
	if (locale === "fr") return fr_date_range_picker__departure_placeholder(inputs)
	if (locale === "it") return it_date_range_picker__departure_placeholder(inputs)
	if (locale === "nl") return nl_date_range_picker__departure_placeholder(inputs)
	return pt_date_range_picker__departure_placeholder(inputs)
};